module.exports = __webpack_public_path__ + "img/mealreminder-text-small-2.33be66fc.png";